import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {StatusCodes} from 'http-status-codes';
import { Observable,throwError  } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BaseHandleErrorService {

  constructor() 
  {}

  public handleError(error: HttpErrorResponse) {
    window.dispatchEvent(new CustomEvent('closeSpinner'));
    let errorMessage = 'Unknown error!';
    if(error!==null)
    {
      errorMessage=String(error);
    }
    
    switch (error.status) {
        case StatusCodes.BAD_REQUEST: {
            errorMessage = `Error: ${error.error.message}`;
            break;
        }
        case StatusCodes.INTERNAL_SERVER_ERROR: {
            window.dispatchEvent(new CustomEvent('server-error-message-eticketing'));
            errorMessage = `Error: ${error.error.message}`;
            break;
        }
        case StatusCodes.UNAUTHORIZED: {
            window.dispatchEvent(new CustomEvent('server-error-message-eticketing'));
            errorMessage = `Error: ${error.error.message}`;
            break;
        }
        default: {
            window.dispatchEvent(new CustomEvent('server-error-message-eticketing'));
            break;
        }
    }
    return throwError(() => new Error(errorMessage))
  }
   
}
